import slice from './slice.editor';
import * as editorTypes from './types.editor';

export const { reducer: editorState, actions: editorActions } = slice;
export { editorTypes };
export { default as editorSaga } from './saga.editor';
export { default as editorSelector } from './selector.editor';
export default slice;
